module.exports = __webpack_public_path__ + "img/engineering__fence--right.e5fafa28.svg";